import { render, staticRenderFns } from "./CarrinhoDetalhesAgrupamento.vue?vue&type=template&id=af65cea8"
import script from "./CarrinhoDetalhesAgrupamento.vue?vue&type=script&lang=js"
export * from "./CarrinhoDetalhesAgrupamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports